/** Interface strings of the data and privacy section and account deletion. */
export const accountMessages = {
  "account.title": { ru: "Данные и приватность", en: "Data and privacy" },
  "account.export.heading": { ru: "Экспорт данных", en: "Data export" },
  "account.export.button": { ru: "Запросить экспорт", en: "Request export" },
  "account.export.note": {
    ru: "Ссылка для скачивания придёт в чат с ботом. В приложении она не показывается.",
    en: "The download link will arrive in the bot chat. It is never shown in the app.",
  },
  "account.export.requested": {
    ru: "Экспорт запрошен. Ссылка придёт в чат с ботом.",
    en: "Export requested. The link will arrive in the bot chat.",
  },
  "account.export.inProgress": {
    ru: "Экспорт уже готовится. Дождитесь ссылки в чате с ботом.",
    en: "An export is already being prepared. Wait for the link in the bot chat.",
  },
  "account.export.cooldown": {
    ru: "Экспорт можно запрашивать не так часто. Повторите после {when}.",
    en: "Exports cannot be requested this often. Try again after {when}.",
  },
  "account.export.cooldownSoon": {
    ru: "Экспорт можно запрашивать не так часто. Повторите позже.",
    en: "Exports cannot be requested this often. Try again later.",
  },
  "account.export.noTelegram": {
    ru: "Ссылку некуда доставить: к аккаунту не привязан Telegram.",
    en: "There is nowhere to deliver the link: no Telegram account is linked.",
  },
  "account.export.failed": {
    ru: "Не удалось запросить экспорт. Попробуйте позже.",
    en: "The export could not be requested. Please try again later.",
  },
  "account.links.heading": { ru: "Активные ссылки", en: "Active links" },
  "account.links.none": {
    ru: "Активных ссылок нет.",
    en: "There are no active links.",
  },
  "account.links.expires": {
    ru: "Действует до {when}",
    en: "Valid until {when}",
  },
  "account.links.downloads": {
    ru: "Осталось скачиваний: {count}",
    en: "Downloads left: {count}",
  },
  "account.links.status.queued": { ru: "В очереди", en: "Queued" },
  "account.links.status.building": { ru: "Готовится", en: "Being prepared" },
  "account.links.status.ready": { ru: "Готова", en: "Ready" },
  "account.links.status.other": { ru: "Ссылка", en: "Link" },
  "account.links.revoke": { ru: "Отозвать", en: "Revoke" },
  "account.links.revokeNumbered": {
    ru: "Отозвать ссылку {n}",
    en: "Revoke link {n}",
  },
  "account.links.revokeAll": { ru: "Отозвать все", en: "Revoke all" },
  "account.links.failed": {
    ru: "Не удалось обновить ссылки. Попробуйте ещё раз.",
    en: "The links could not be updated. Please try again.",
  },
  "account.clear.heading": { ru: "Очистка данных", en: "Clear data" },
  "account.clear.button": { ru: "Очистить данные", en: "Clear data" },
  "account.clear.intro": {
    ru: "Выберите, что удалить. Аккаунт останется, но удалённое не вернуть.",
    en: "Choose what to remove. The account stays, but removed data cannot be restored.",
  },
  "account.clear.reminders": { ru: "Напоминания", en: "Reminders" },
  "account.clear.records": { ru: "Записи в разделах", en: "Section records" },
  "account.clear.assistant_memory": {
    ru: "Память ассистента",
    en: "Assistant memory",
  },
  "account.clear.assistant_history": {
    ru: "История ассистента",
    en: "Assistant history",
  },
  "account.clear.transcripts": {
    ru: "Расшифровки голосовых",
    en: "Voice transcripts",
  },
  "account.clear.confirmLabel": {
    ru: "Введите CLEAR для подтверждения",
    en: "Type CLEAR to confirm",
  },
  "account.clear.submit": { ru: "Очистить", en: "Clear" },
  "account.clear.done": { ru: "Данные очищены.", en: "Data cleared." },
  "account.clear.failed": {
    ru: "Не удалось очистить данные. Ничего не удалено, попробуйте ещё раз.",
    en: "The data could not be cleared. Try again.",
  },
  "account.dialog.cancel": { ru: "Отмена", en: "Cancel" },
  "account.dialog.close": { ru: "Закрыть", en: "Close" },
  "account.delete.button": { ru: "Удалить аккаунт", en: "Delete account" },
  "account.delete.title": { ru: "Удаление аккаунта", en: "Delete account" },
  "account.delete.step": { ru: "Шаг {n} из 3", en: "Step {n} of 3" },
  "account.delete.offerExport": {
    ru: "Перед удалением можно забрать копию данных. Ссылка придёт в чат с ботом.",
    en: "You can take a copy of your data first. The link will arrive in the bot chat.",
  },
  "account.delete.skip": {
    ru: "Продолжить без экспорта",
    en: "Continue without export",
  },
  "account.delete.continue": { ru: "Продолжить", en: "Continue" },
  "account.delete.linksIntro": {
    ru: "Эти ссылки на экспорт ещё действуют. Отзовите их, если не хотите, чтобы по ним скачали данные.",
    en: "These export links are still valid. Revoke them if you do not want the data downloaded through them.",
  },
  "account.delete.finalIntro": {
    ru: "Аккаунт будет удалён безвозвратно через 30 дней, примерно {when}. До этого срока удаление можно отменить.",
    en: "The account will be erased permanently in 30 days, around {when}. You can cancel before then.",
  },
  "account.delete.confirmLabel": {
    ru: "Введите DELETE для подтверждения",
    en: "Type DELETE to confirm",
  },
  "account.delete.submit": { ru: "Удалить аккаунт", en: "Delete account" },
  "account.delete.done": {
    ru: "Удаление запланировано. Данные будут стёрты {when}.",
    en: "Deletion is scheduled. Your data will be erased on {when}.",
  },
  "account.delete.linksRemain": {
    ru: "Действующих ссылок на экспорт: {count}",
    en: "Export links still active: {count}",
  },
  "account.delete.finish": { ru: "Готово", en: "Done" },
  "account.delete.notDeletable": {
    ru: "Этот аккаунт сейчас нельзя удалить.",
    en: "This account cannot be deleted right now.",
  },
  "account.delete.failed": {
    ru: "Не удалось запланировать удаление. Попробуйте ещё раз.",
    en: "Deletion could not be scheduled. Please try again.",
  },
  "account.pending.title": {
    ru: "Аккаунт будет удалён",
    en: "Your account is scheduled for deletion",
  },
  "account.pending.body": {
    ru: "Данные будут стёрты безвозвратно {when}. До этого момента аккаунт можно восстановить.",
    en: "Your data will be erased permanently on {when}. Until then you can restore the account.",
  },
  "account.pending.bodyUnknown": {
    ru: "Данные будут стёрты безвозвратно после окончания срока отмены. До этого момента аккаунт можно восстановить.",
    en: "Your data will be erased permanently when the cancellation window ends. Until then you can restore the account.",
  },
  "account.pending.restore": {
    ru: "Восстановить аккаунт",
    en: "Restore account",
  },
  "account.pending.failed": {
    ru: "Не удалось восстановить аккаунт. Попробуйте ещё раз.",
    en: "The account could not be restored. Please try again.",
  },
  "account.pending.revokeLinks": {
    ru: "Отозвать все ссылки на экспорт",
    en: "Revoke all export links",
  },
  "account.pending.revokeDone": {
    ru: "Все ссылки на экспорт отозваны.",
    en: "All export links have been revoked.",
  },
  "account.pending.revokeFailed": {
    ru: "Не удалось отозвать ссылки. Попробуйте ещё раз.",
    en: "The export links could not be revoked. Please try again.",
  },
} as const;
